import { METHOD_TYPES } from "./../../stateCommon/consts";
import { invokeCurrentMethodKey } from "./../utils/consts";
export const getPostDataArgs = () => [{
  id: 'postData',
  title: '提交的数据对象'
}];
export const invokeCode = `await ${invokeCurrentMethodKey}();`;
export const invokeReturnCode = `const res = await ${invokeCurrentMethodKey}();`;
export const logResCode = 'console.log(res);';
export const logListDataCode = 'console.log(\'listData:\',source.listData);';
export const logTotalCode = 'console.log(\'total:\',source.total);';
export const listCountDebugCode = `${invokeCode}
${logTotalCode}
${logListDataCode}`;
export const invokeAndLogDebugCode = `${invokeReturnCode}
${logResCode}`;
/**
 * 生成可视化或代码配置
 * @param options
 * @param getCodeInfo
 * @param getFormInfo
 * @returns
 */
export function selectConfig(options, getCodeInfo, getFormInfo, isInit = false) {
  const {
    isFormType,
    tpl,
    cgi,
    isAuto
  } = options;
  const canToForm = Boolean(!isAuto || isInit); // 是否可以转可视化模式
  // 匹配生成代码是不支持可视化的
  const isForm = canToForm && isFormType;
  const meta = {
    type: isForm ? METHOD_TYPES.form : METHOD_TYPES.code,
    meta: {
      tpl,
      cgi: cgi,
      convertible: canToForm
    }
  };
  if (isForm) {
    const formInfo = getFormInfo(options);
    return {
      ...meta,
      code: '',
      args: [],
      formInfo
    };
  }
  const res = getCodeInfo(options);
  return {
    ...meta,
    ...res
  };
}
//# sourceMappingURL=common.js.map
